import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import titleize from 'underscore.string/titleize';
import { guestServices as statusConfig } from '../config/service-options';
import AffiliateConfig from '../containers/AffiliateConfig';
import { localize, t } from '../i18n';

const GuestServicesBadge = function GuestServicesBadge(props) {
  const {
    className,
    labelClassName,
    label,
  } = props;
  let {
    status,
  } = props;

  const wrapperClasses = ['uk-grid'];
  const labelClasses = ['uk-width-small-1-1'];
  const badgeClasses = ['uk-badge'];
  if (!status) {
    status = 'not_specified';
  }
  let statusLabel = titleize(status.replace(/_/g, ' '));

  const statusCfg = _.find(statusConfig, { value: status });
  if (statusCfg) {
    badgeClasses.push(statusCfg.badgeCls);
    statusLabel = statusCfg.label;
  }

  if (className) {
    wrapperClasses.push(className);
  }

  if (labelClassName) {
    labelClasses.push(labelClassName);
  }

  return (
    <AffiliateConfig has="gems_guest_service_enabled">
      <div className={wrapperClasses.join(' ')}>
        <div className={labelClasses.join(' ')}>{props.t(label)}</div>
        <div className="uk-width-small-1-1">
          <span className={badgeClasses.join(' ')}>{props.t(statusLabel)}</span>
        </div>
      </div>
    </AffiliateConfig>
  );
};

GuestServicesBadge.propTypes = {
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  label: PropTypes.string,
  status: PropTypes.string,
  t: PropTypes.func.isRequired,
};

GuestServicesBadge.defaultProps = {
  label: t('Guest Services Status'),
  status: 'not_specified',
};

export default localize(GuestServicesBadge);



// WEBPACK FOOTER //
// ./src/components/GuestServicesBadge.js